import { useMutation } from 'react-query';
import { useStore } from '../../context';
import { Actions } from '../../store';
import { authService } from '../../services';
import { signinRolesLabel } from '../../const';

const getNormalUser = (user: any) => {
  if (user.yardCompanyEmployee) {
    user.type = signinRolesLabel[user.yardCompanyEmployee.role];
  }
  if (user.yardEmployee) {
    user.type = signinRolesLabel[user.yardEmployee.role];
  }
  if (user.clientEmployee) {
    user.type = signinRolesLabel[user.clientEmployee.role];
  }

  return user;
};

export const useSigninMutation = () => {
  const { dispatch } = useStore();
  let userBase: any = localStorage.getItem('user');
  userBase = !userBase ? null : JSON.parse(userBase);
  let email: any;

  return useMutation(
    async (props: any) => {
      if (userBase) return Promise.resolve(null);

      email = props.email;

      return authService.signin(props);
    },
    {
      onSuccess: (res: any) => {
        if (res && !userBase) {
          userBase = getNormalUser({
            ...res.data.data,
            email,
            type: res.data.data.belongsTo,
          });

          localStorage.setItem('user', JSON.stringify(userBase));
        }

        dispatch({ type: Actions.SET_USER_DATA, payload: userBase });

        return res;
      },
      onError: () => {
        localStorage.removeItem('user');
      },
    },
  );
};

export const useLogoutMutation = () => {
  return useMutation(authService.logout);
};
